import { jsx as c } from "react/jsx-runtime";
import { Accordion as t } from "./styles74.mjs";
const m = ({ testId: o, ...r }) => /* @__PURE__ */ c(t, { "data-testid": o, ...r });
export {
  m as Accordion
};
//# sourceMappingURL=index109.mjs.map
